export const DEFAULT_USECASE_CATEGORY_OPTIONS = [
  { value: 'redaction', label: 'Rédaction' },
  { value: 'infographie', label: 'Infographie' },
  { value: 'visuel', label: 'Visuel' },
  { value: 'presentation', label: 'Présentation' },
  { value: 'video', label: 'Vidéo' },
  { value: 'audio', label: 'Audio' },
  { value: 'analyse', label: 'Analyse' },
];

const LABEL_MAP: Record<string, string> = DEFAULT_USECASE_CATEGORY_OPTIONS.reduce(
  (acc, option) => {
    acc[option.value] = option.label;
    return acc;
  },
  {} as Record<string, string>
);

const formatWord = (word: string) => word.charAt(0).toUpperCase() + word.slice(1);

export const formatUseCaseCategoryLabel = (category: string) => {
  if (!category) {
    return 'Non catégorisé';
  }

  if (LABEL_MAP[category]) {
    return LABEL_MAP[category];
  }

  const normalized = category.replace(/[-_]/g, ' ').toLowerCase();
  return normalized
    .split(' ')
    .filter(Boolean)
    .map(formatWord)
    .join(' ');
};

export const mergeUseCaseCategories = (
  existing: string[],
  nextCategories: string | string[]
) => {
  const next = Array.isArray(nextCategories) ? nextCategories : [nextCategories];
  const unique = new Set([...existing, ...next.filter(Boolean)]);
  return Array.from(unique);
};

